import { useState, useEffect } from 'react';

/**
 * @hook useResourceSidebar
 * @description Refined hook for managing ResourceSidebar state.
 * Removed legacy split/collapse logic to favor a clean 3-tab architecture.
 * 
 * @param {Object} options
 * @param {string} options.persistenceKey - Key for localStorage (optional).
 */
export default function useResourceSidebar({ persistenceKey = 'sidebar' } = {}) {
    // Search states for each tab
    const [searchTop, setSearchTop] = useState('');      // For Personal
    const [searchBottom, setSearchBottom] = useState('');   // For Vehicles
    const [searchFull, setSearchFull] = useState('');     // For Kolonnen

    // Category expansion (for vehicles)
    const [expandedGroups, setExpandedGroups] = useState(() => {
        const saved = localStorage.getItem(`resource_sidebar_${persistenceKey}_expanded`);
        return saved ? JSON.parse(saved) : {};
    });

    // Persist expanded groups
    useEffect(() => {
        localStorage.setItem(`resource_sidebar_${persistenceKey}_expanded`, JSON.stringify(expandedGroups));
    }, [expandedGroups, persistenceKey]);

    /**
     * Toggle a specific group expansion (e.g. vehicle category)
     * @param {string} groupId 
     */
    const toggleGroup = (groupId) => {
        setExpandedGroups(prev => ({
            ...prev,
            [groupId]: !prev[groupId]
        }));
    };

    return {
        searchTop,
        setSearchTop,
        searchBottom,
        setSearchBottom,
        searchFull,
        setSearchFull,
        expandedGroups,
        toggleGroup
    };
}
